export default function StandardBox (props:any) {

    return (
        <div className="standard-box" style={props.style}>
            {props.children}
        </div>
    )

}